import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "blockSize", "as", "display", "flex", "size", "variant"];
import styled from 'styled-components';
import { LayoutHorizontal } from '../Layout/LayoutHorizontal';
import { jsx as _jsx } from "react/jsx-runtime";
const iconColorMap = {
  brand: 'fill-primary-default',
  breeze: 'fill-breeze-brand-default',
  'breeze-gradient-dark': 'fill-breeze-brand-default',
  'breeze-gradient-light': 'fill-breeze-brand-default',
  'breeze-gradient-medium': 'fill-breeze-brand-default',
  danger: 'fill-accent-red-default',
  disabled: 'text-core-disabled',
  info: 'fill-info-default',
  inverse: 'fill-surface-default',
  light: 'icon-core-subtle',
  onboarding: 'fill-accent-purple-default',
  success: 'fill-accent-green-default',
  warning: 'fill-accent-yellow-default',
  transparent: 'transparent'
};
const iconSizeMap = {
  default: '1em',
  xxs: '16px',
  xs: '24px',
  sm: '48px',
  md: '64px',
  lg: '72px',
  xl: '96px'
};
const getThemeColor = ({
  theme,
  variant
}) => {
  if (variant === 'default') {
    return 'currentColor';
  } else if (variant === 'breeze') {
    return 'var(--layout-lib-breeze-brand)';
  } else if (variant === 'transparent') {
    return 'transparent';
  } else {
    return theme.color[iconColorMap[variant]];
  }
};
const getIconFill = variant => {
  if (variant === 'breeze-gradient-dark') {
    return 'url(#breeze-intelligence-kit-gradient-dark)';
  } else if (variant === 'breeze-gradient-light') {
    return 'url(#breeze-intelligence-kit-gradient-light)';
  } else if (variant === 'breeze-gradient-medium') {
    return 'url(#breeze-intelligence-kit-gradient-medium)';
  } else {
    return 'currentColor';
  }
};
const Container = styled(LayoutHorizontal).withConfig({
  displayName: "IconContainer__Container",
  componentId: "s1wrrn-0"
})(["color:", ";font-size:", ";svg{fill:", ";block-size:1em;inline-size:1em;}"], ({
  theme,
  $variant = 'default'
}) => getThemeColor({
  theme,
  variant: $variant
}), ({
  $size
}) => iconSizeMap[$size], ({
  $variant = 'default'
}) => getIconFill($variant));
export const IconContainer = _ref => {
  let {
      children,
      blockSize = '1em',
      as = 'span',
      display = 'inline-flex',
      flex = '0 0 auto',
      size = 'default',
      variant = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Container, Object.assign({}, rest, {
    $size: size,
    $variant: variant,
    alignItems: "center",
    blockSize: blockSize,
    display: display,
    flex: flex,
    forwardedAs: as,
    lineHeight: 1,
    children: children
  }));
};